import React from 'react';

const ZombiePurgeAnimation = () => {
	return (
		<div className='fixed top-0 h-screen w-screen z-[9999] bg-[rgba(0,0,0,0.9)] '
			id='zombie-purge-animation'>
			<video autoPlay
				className='w-screen object-contain'
				width="100%"
				height="100%">
				<source src="https://public.rareapepes.com/zombie-purging.mp4" />
			</video>
		</div>
	);
};

export default ZombiePurgeAnimation;
